export const getCostDisplay = (cost: number, currencySymbol: string) =>
  Number.isInteger(cost) ? `${currencySymbol}${cost}` : `${currencySymbol}${cost.toFixed(2)}`;
